export const DEFAULT_PROPS = {
  views: ["year", "month", "day"],
  // We need to overwrite the media query used by mui because their default one
  // doesn't work in our integration tests. This is based off the breakpoint
  // for rendering the mobile menu in styles/_responsive.scss
  desktopModeMediaQuery: "@media (min-width: 992px)",
}

export const DEFAULT_SLOT_PROPS = {
  popper: {
    disablePortal: true,
  },
  openPickerButton: {
    tabIndex: -1,
  },
  clearButton: {
    tabIndex: -1,
  },
}
